module.exports = __webpack_public_path__ + "static/media/instagram.c90a173a.svg";